import { useTranslation } from "react-i18next";
import { IcoGiftGradient } from "src/assets";
interface RedeemButtonProps {
  onClick: () => void;
}

export default function RedeemButton({ onClick }: RedeemButtonProps) {
  const { t } = useTranslation();
  return (
    <div
      className="flex h-12 max-h-[50px] w-full cursor-pointer flex-row items-center justify-center gap-2  rounded-lg border border-[#563CAD] bg-[#25145D] py-2 px-2 text-sm font-bold uppercase leading-6 text-white transition-colors hover:bg-[#301b74] active:bg-[#0d042b]"
      onClick={onClick}
    >
      <IcoGiftGradient className="hidden h-5 w-5  min-[360px]:block" />
      {t("redeem gifts")}
    </div>
  );
}
